import React, { useState, useEffect } from 'react';
import jsPDF from 'jspdf';

const product = [
    {
        "mpId": 1,
        "mpProductName": "TRACe PA"
    },
    {
        "mpId": 2,
        "mpProductName": "CAFe"
    },
    {
        "mpId": 3,
        "mpProductName": "Doc Assist"
    },
    {
        "mpId": 4,
        "mpProductName": "TRACe ENT"
    },
    {
        "mpId": 5,
        "mpProductName": "EDICT"
    },
    {
        "mpId": 6,
        "mpProductName": "All"
    }
]

const CustomerDetailsModal = ({ isOpen, onClose, customerID }) => {
    const [customerById, setCustomerById] = useState({});
    const [moduleName, setModuleName] = useState([]);
    const [formData, setFormData] = useState({
        module_Id: customerById?.moduleIds || []
    });
    
    console.log('cust-iD :', customerID);

    useEffect(() => {
        if (!customerID) return;
        const fetchCustomerById = async (id) => {
            try {
                setCustomerById(null); // Reset state before fetching new data

                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/Customer/GetCustomerDetailsByName?CustomerId=${id}`);

                if (!response.ok) {
                    console.error("API request failed.");
                    return;
                }

                const data = await response.json();
                console.log("Received customer data***:", data); // Debugging log

                setCustomerById({ ...data }); // Ensure React detects the change
            } catch (error) {
                console.error("Error fetching customer data:", error);
            }
        };
        fetchCustomerById(customerID);
    }, [customerID]);


    // Fetch modules by product name
    const moduleNamesByproduct = async (pname) => {
        if (!pname) {
            setModuleName([]); // Reset modules if no product is selected
            return;
        }

        const apiUrl = `${process.env.REACT_APP_API_URL}/api/Customer/GetModulesByProductName?productname=${pname}`;

        try {
            const response = await fetch(apiUrl);
            if (!response.ok) {
                console.log('Something went wrong!', response.statusText);
                return;
            }
            const data = await response.json();
            setModuleName(data.moduleNames || []);
        } catch (error) {
            console.log(error);
        }
    };

    // When productId changes, map product name and fetch corresponding modules
    useEffect(() => {
        if (customerById?.mcrMpId) {
            const selectedProduct = product.find(p => p.mpId === customerById.mcrMpId);
            if (selectedProduct) {
                moduleNamesByproduct(selectedProduct.mpProductName);
            }
        }
    }, [customerById?.mcrMpId, product]);

    // Handle checkbox change
    const handleCheckboxChange = (e, moduleId) => {
        const { checked } = e.target;
        setFormData(prevData => {
            const updatedModuleIds = checked
                ? [...prevData.module_Id, moduleId] // Add module if checked
                : prevData.module_Id.filter(id => id !== moduleId); // Remove module if unchecked
            return { ...prevData, module_Id: updatedModuleIds };
        });
    };

    useEffect(() => {
        // Ensure the initial formData is set based on the customerById moduleIds
        setFormData({
            module_Id: customerById?.moduleIds || []
        });
    }, [customerById]);


    const downloadPDF = () => {
        const doc = new jsPDF();

        let y = 10; // Starting position for text

        doc.setFontSize(16);
        doc.text('Customer Details', 105, y, { align: 'center' });
        y += 10;

        doc.setFontSize(12);
        const labels = {
            mcrId: "Customer ID",
            mcrCustomerName: "Customer Name",
            mcrCustomerCode: "Customer Code",
            mcrCustomerEmail: "Email",
            mcrCustomerTelephoneNo: "Phone",
            mcrContactPersonName: "Contact Name",
            mcrContactPersonPhoneNo: "Contact Phone",
            mcrContactPersonEmail: "Contact Email",
            mcrGstno: "GST No",
            mcrNumberOfUsers: "Number of Users",
            mcrAddress: "Address",
            mcrCity: "City",
            mcrState: "State",
            mcrBillingFrequency: "Billing Frequency",
            mcrFromDate: "From Date",
            mcrToDate: "To Date",
            mcrRnwlFee: "Renewal Fee",
            mcrDataSize: "Data Size",
            mcrNumberOfCustomers: "Number of Customers",
        };

        // Add basic customer details
        Object.entries(labels).forEach(([key, label]) => {
            const value = customerById[key] || "N/A";
            doc.text(`${label}: ${value}`, 10, y);
            y += 10;

            // Check if adding more text exceeds the page height
            if (y > 280) {
                doc.addPage();
                y = 10;
            }
        });

        // Add product name based on product ID
        const productName = product.find(p => p.mpId === customerById.mcrMpId)?.mpProductName || "N/A";
        doc.text(`Product Name: ${productName}`, 10, y);
        y += 10;

        // Add module names instead of IDs
        if (moduleName.length > 0) {
            doc.text('Modules:', 10, y);
            y += 10;

            moduleName.forEach(module => {
                doc.text(`- ${module.moduleName}`, 15, y);
                y += 10;

                if (y > 280) {
                    doc.addPage();
                    y = 10;
                }
            });
        } else {
            doc.text('Modules: N/A', 10, y);
            y += 10;
        }

        // Remove the extra blank page if content fits on a single page
        if (doc.internal.getNumberOfPages() > 1) {
            const currentPage = doc.internal.pages[doc.internal.getNumberOfPages()];
            if (currentPage.length === 0) {
                doc.deletePage(doc.internal.getNumberOfPages());
            }
        }

        doc.save('CustomerDetails.pdf');
    };



    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center p-4">
            <div className="text-xs bg-white w-full max-w-4xl p-6 rounded-lg shadow-lg overflow-auto animate-scale-up">
                <h2 className="text-xl font-semibold text-center mb-6">Customer Details</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                    <div>
                        <label className='font-semibold  text-black'>Customer Name : </label>
                        <span>{customerById?.mcrCustomerName || 'N/A'}</span>
                    </div>
                    <div>
                        <label className='font-semibold  text-black'>Customer Code : </label>
                        <span>{customerById?.mcrCustomerCode || 'N/A'}</span>
                    </div>
                    <div>
                        <label className='font-semibold  text-black'>Email : </label>
                        <span>{customerById?.mcrCustomerEmail || 'N/A'}</span>
                    </div>
                    <div>
                        <label className='font-semibold  text-black'>Phone : </label>
                        <span>{customerById?.mcrCustomerTelephoneNo || 'N/A'}</span>
                    </div>
                    <div>
                        <label className='font-semibold  text-black'>Number of Customers : </label>
                        <span>{customerById?.mcrNumberOfCustomers || 'N/A'}</span>
                    </div>
                    <div>
                        <label className='font-semibold  text-black'>Data Size : </label>
                        <span>{customerById?.mcrDataSize || 'N/A'}</span>
                    </div>
                    <div>
                        <label className='font-semibold  text-black'>Contact Name : </label>
                        <span>{customerById?.mcrContactPersonName || 'N/A'}</span>
                    </div>
                    <div>
                        <label className='font-semibold  text-black'>Contact Phone:</label>
                        <span>{customerById?.mcrContactPersonPhoneNo || 'N/A'}</span>
                    </div>
                    <div>
                        <label className='font-semibold  text-black'>Contact Email : </label>
                        <span>{customerById?.mcrContactPersonEmail || 'N/A'}</span>
                    </div>
                    <div>
                        <label className='font-semibold  text-black'>GST No : </label>
                        <span>{customerById?.mcrGstno || 'N/A'}</span>
                    </div>
                    <div>
                        <label className='font-semibold  text-black'>Number of Users : </label>
                        <span>{customerById?.mcrNumberOfUsers || 'N/A'}</span>
                    </div>
                    <div>
                        <label className='font-semibold  text-black'>Address : </label>
                        <span>{customerById?.mcrAddress || 'N/A'}</span>
                    </div>
                    <div>
                        <label className='font-semibold  text-black'>City : </label>
                        <span>{customerById?.mcrCity || 'N/A'}</span>
                    </div>
                    <div>
                        <label className='font-semibold  text-black'>State : </label>
                        <span>{customerById?.mcrState || 'N/A'}</span>
                    </div>
                    <div>
                        <label className='font-semibold  text-black'>Billing Frequency : </label>
                        <span>{customerById?.mcrBillingFrequency || 'N/A'}</span>
                    </div>
                    <div>
                        <label className='font-semibold  text-black'>Renewal Fee : </label>
                        <span>{customerById?.mcrRnwlFee || 'N/A'}</span>
                    </div>
                    <div>
                        <label className='font-semibold  text-black'>From Date : </label>
                        <span>{customerById?.mcrFromDate || 'N/A'}</span>
                    </div>
                    <div>
                        <label className='font-semibold  text-black'>To Date : </label>
                        <span>{customerById?.mcrToDate || 'N/A'}</span>
                    </div>
                    <div>
                        <label className='font-semibold  text-black'>Product Key : </label>
                        <span>{customerById?.mcrProductKey || 'N/A'}</span>
                    </div>

                </div>
                <div className='mt-3'>
                    {/* Display Product Name */}
                    <div>
                        <label className="font-semibold text-black">Product : </label>
                        <span>{product.find(p => p.mpId === customerById?.mcrMpId)?.mpProductName || 'N/A'}</span>
                    </div>
                    {/* Display Modules */}
                    <div className="col-span-4 flex mt-3">
                        <lable className='font-semibold  text-black'>
                            Modules :
                        </lable>
                        <div>
                            {moduleName.length > 0 ? (
                                <ul className="space-y-2">
                                    {moduleName.map((module) => (
                                        <li key={module.moduleId}>
                                            <label className="form-label flex items-center gap-2.5 text-nowrap">
                                                <input
                                                    className="checkbox"
                                                    name="check"
                                                    type="checkbox"
                                                    value={module.moduleId}
                                                    checked={formData.module_Id.includes(module.moduleId)}
                                                    onChange={(e) => handleCheckboxChange(e, module.moduleId)}
                                                    readOnly
                                                />
                                                {module.moduleName}
                                            </label>
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <p className="text-gray-500">No modules available.</p>
                            )}
                        </div>
                    </div>
                </div>
                <div className="flex justify-end space-x-4 pt-6">
                    <button
                        className="bg-red-500 text-white px-6 py-2 rounded-lg hover:bg-red-600 transition duration-300"
                        onClick={onClose}
                    >
                        Close
                    </button>
                    <button
                        className="bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600 transition duration-300"
                        onClick={downloadPDF}
                    >
                        Download PDF
                    </button>
                </div>
            </div>
            {/* Modal Animation */}
            <style>{`
        @keyframes scaleUp {
          0% {
            transform: scale(0.5);
            opacity: 0;
          }
          100% {
            transform: scale(1);
            opacity: 1;
          }
        }
        .animate-scale-up {
          animation: scaleUp 0.3s ease-out;
        }
      `}</style>
        </div>
    );
};

export default CustomerDetailsModal;
